import { render, staticRenderFns } from "./PfContributions.vue?vue&type=template&id=69efdee5"
import script from "./PfContributions.vue?vue&type=script&lang=js"
export * from "./PfContributions.vue?vue&type=script&lang=js"
import style0 from "./PfContributions.vue?vue&type=style&index=0&id=69efdee5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports